import { Schema } from "@comparaonline/products-schema";

import { ProviderData } from "../../../../../../lib/appContext/types";
import {
  getCaptureCta,
  getFormCta,
  getLandingFormCta,
  getProductImage,
  hasForm,
  isLandingForm,
  ICta
} from "../../../../../../models/product";
import { useFlagProps } from "../../../../../products/helpers/useFlagProps";
import { useMainAttribute } from "../../../../../products/helpers/useMainAttribute";
import { HeaderProps } from "../../StickyHeader/Header";

const getCtaFn = (appContext: ProviderData) => {
  if (isLandingForm(appContext)) {
    return getLandingFormCta;
  }
  return hasForm(appContext) ? getFormCta : getCaptureCta;
};

export const getHeaderProps = (
  appContext: ProviderData,
  product: Schema.ProductListProduct,
  onClickCta?: ICta["onClick"]
): HeaderProps => {
  const getCta = getCtaFn(appContext);
  const getMainAttribute = useMainAttribute();
  const getFlagProps = useFlagProps();
  const businessUnitName = appContext.businessUnitConfig.name;

  return {
    attributeProps: getMainAttribute(product),
    ctaProps: getCta(appContext, product, onClickCta),
    flagProps: getFlagProps(product),
    imageProps: getProductImage(product, businessUnitName),
    ratingProps: product.reviews
  };
};
